import {createSlice} from '@reduxjs/toolkit';
import {setActiveVariant} from './actions';
import {Variant} from './types';

const initialState = {
  activeVariant: 'A' as Variant,
};

const slice = createSlice({
  name: 'usability',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setActiveVariant, (state, action) => {
      state.activeVariant = action.payload;
    });
  },
});

export const {reducer: usabilityReducer} = slice;
